export const constellationData = {
  aries: {
    name: 'Aries',
    chineseName: '白羊座',
    date: '3/21 - 4/19',
    element: 'fire',
    details: {
      personality: '充满活力、热情、直接，但有时缺乏耐心。他们是天生的领导者，喜欢挑战和冒险。',
      strengths: ['勇敢', '有决断力', '自信', '热情'],
      weaknesses: ['没耐心', '冲动', '好斗', '以自我为中心'],
      career: '企业家、运动员、军人、销售主管',
      myth: '白羊座代表着神话中的金羊，它曾拯救了王子弗里克索斯。为了纪念这只勇敢的羊，宙斯将它升上天空，成为了白羊座。',
      compatibility: '狮子座、射手座',
    },
  },
  taurus: {
    name: 'Taurus',
    chineseName: '金牛座',
    date: '4/20 - 5/20',
    element: 'earth',
    details: {
      personality: '可靠、有耐心、务实，但有时固执。他们热爱美好事物，对物质世界有强烈的追求。',
      strengths: ['可靠', '有耐心', '实际', '负责任'],
      weaknesses: ['固执', '占有欲强', '不妥协', '懒惰'],
      career: '金融顾问、设计师、厨师、房地产经纪人',
      myth: '金牛座代表宙斯为了追求美丽的欧罗巴公主而化身的白色公牛。',
      compatibility: '处女座、摩羯座',
    },
  },
  gemini: {
    name: 'Gemini',
    chineseName: '双子座',
    date: '5/21 - 6/21',
    element: 'air',
    details: {
      personality: '适应性强、好奇、聪明，但可能三心二意。他们是优秀的沟通者，喜欢社交和学习新事物。',
      strengths: ['温柔', '深情', '好奇', '适应力强'],
      weaknesses: ['紧张', '矛盾', '优柔寡断', '三心二意'],
      career: '记者、作家、教师、公关',
      myth: '双子座代表斯巴达王后丽达所生的双胞胎兄弟，他们一位是神，一位是凡人，因兄弟情深而感动了宙斯。',
      compatibility: '天秤座、水瓶座',
    },
  },
  cancer: {
    name: 'Cancer',
    chineseName: '巨蟹座',
    date: '6/22 - 7/22',
    element: 'water',
    details: {
      personality: '情感丰富、有同情心、忠诚，但可能情绪化和缺乏安全感。他们非常重视家庭和亲密关系。',
      strengths: ['坚韧', '富有想象力', '忠诚', '有说服力'],
      weaknesses: ['情绪化', '悲观', '多疑', '缺乏安全感'],
      career: '护士、教师、心理学家、室内设计师',
      myth: '巨蟹座代表在赫拉克勒斯与九头蛇战斗时，被赫拉派去帮助九头蛇的巨蟹。',
      compatibility: '天蝎座、双鱼座',
    },
  },
  leo: {
    name: 'Leo',
    chineseName: '狮子座',
    date: '7/23 - 8/22',
    element: 'fire',
    details: {
      personality: '自信、有创造力、热情，但可能傲慢和固执。他们喜欢成为众人瞩目的焦点，并具有天生的领导才能。',
      strengths: ['有创造力', '热情', '慷慨', '幽默'],
      weaknesses: ['傲慢', '固执', '懒惰', '不灵活'],
      career: '演员、经理、设计师、政治家',
      myth: '狮子座代表被赫拉克勒斯杀死的尼米亚猛狮，这头狮子刀枪不入，最终被英雄扼死。',
      compatibility: '白羊座、射手座',
    },
  },
  virgo: {
    name: 'Virgo',
    chineseName: '处女座',
    date: '8/23 - 9/22',
    element: 'earth',
    details: {
      personality: '谦虚、务实、勤奋，但有时过于挑剔和保守。他们注重细节，追求完美，并具有很强的分析能力。',
      strengths: ['忠诚', '善于分析', '善良', '勤劳'],
      weaknesses: ['害羞', '爱担忧', '过于挑剔', '工作狂'],
      career: '编辑、评论家、教师、技术员',
      myth: '处女座代表农业女神得墨忒耳，她掌管着谷物的丰收。她的形象是一位手持麦穗的贞洁少女。',
      compatibility: '金牛座、摩羯座',
    },
  },
  libra: {
    name: 'Libra',
    chineseName: '天秤座',
    date: '9/23 - 10/23',
    element: 'air',
    details: {
      personality: '合作、公正、优雅，但可能优柔寡断和避免冲突。他们追求和谐与平衡，是出色的外交家。',
      strengths: ['合作', '外交', '优雅', '理想主义'],
      weaknesses: ['优柔寡断', '避免对抗', '会记仇', '自怜'],
      career: '外交官、法官、艺术品经销商、人力资源经理',
      myth: '天秤座代表着正义女神阿斯特赖亚手中的天平，用以衡量善恶。当人类堕落后，她将天平升上天空。',
      compatibility: '双子座、水瓶座',
    },
  },
  scorpio: {
    name: 'Scorpio',
    chineseName: '天蝎座',
    date: '10/24 - 11/22',
    element: 'water',
    details: {
      personality: '足智多谋、勇敢、热情，但可能多疑和有报复心。他们情感强烈，对事物有深刻的洞察力。',
      strengths: ['足智多谋', '勇敢', '热情', '真正的朋友'],
      weaknesses: ['不信任', '嫉妒', '神秘', '暴力'],
      career: '侦探、科学家、外科医生、研究员',
      myth: '天蝎座代表派去杀死猎人奥利安的天蝎。为了防止他们再次争斗，宙斯将他们分别放在天空的两端。',
      compatibility: '巨蟹座、双鱼座',
    },
  },
  sagittarius: {
    name: 'Sagittarius',
    chineseName: '射手座',
    date: '11/23 - 12/21',
    element: 'fire',
    details: {
      personality: '慷慨、理想主义、幽默，但可能承诺过多和不耐烦。他们热爱自由，喜欢探索和旅行。',
      strengths: ['慷慨', '理想主义', '幽默感强', '精力充沛'],
      weaknesses: ['承诺过多', '非常不耐烦', '言语不讳', '三分钟热度'],
      career: '旅行家、哲学家、教师、出版商',
      myth: '射手座代表着神话中的半人马喀戎，他是一位智慧的导师，培养了许多希腊英雄。',
      compatibility: '白羊座、狮子座',
    },
  },
  capricorn: {
    name: 'Capricorn',
    chineseName: '摩羯座',
    date: '12/22 - 1/19',
    element: 'earth',
    details: {
      personality: '负责任、有纪律、有自制力，但可能悲观和无情。他们是天生的管理者，有很强的职业抱负。',
      strengths: ['负责任', '有纪律', '自制力', '好经理'],
      weaknesses: ['无所不知', '无情', '悲观', '期望最坏'],
      career: '经理、行政人员、工程师、科学家',
      myth: '摩羯座代表着牧神潘，他在一次宴会上为躲避怪物而跳入尼罗河，上半身是羊，下半身是鱼。',
      compatibility: '金牛座、处女座',
    },
  },
  aquarius: {
    name: 'Aquarius',
    chineseName: '水瓶座',
    date: '1/20 - 2/18',
    element: 'air',
    details: {
      personality: '独立、原创、人道主义，但可能不妥协和疏远。他们是思想家和理想主义者，希望让世界变得更美好。',
      strengths: ['进步', '原创', '独立', '人道主义'],
      weaknesses: ['情绪表达不畅', '喜怒无常', '不妥协', '孤僻'],
      career: '科学家、发明家、社会工作者、演员',
      myth: '水瓶座代表特洛伊王子甘尼米德，他因俊美而被宙斯带到奥林匹斯山，成为众神的倒酒者。',
      compatibility: '双子座、天秤座',
    },
  },
  pisces: {
    name: 'Pisces',
    chineseName: '双鱼座',
    date: '2/19 - 3/20',
    element: 'water',
    details: {
      personality: '富有同情心、艺术气息、直觉敏锐，但可能多愁善感和渴望逃避现实。他们非常富有同情心，并具有强大的艺术才能。',
      strengths: ['富有同情心', '艺术性', '直觉', '温柔'],
      weaknesses: ['多愁善感', '渴望逃避现实', '意志薄弱', '容易受骗'],
      career: '艺术家、音乐家、治疗师、兽医',
      myth: '双鱼座代表爱神阿佛洛狄忒和她的儿子厄洛斯，为了躲避怪物提丰，他们化作两条鱼跳入河中。',
      compatibility: '巨蟹座、天蝎座',
    },
  },
};
